import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mat-like-stepper',
  templateUrl: './mat-like-stepper.component.html',
  styleUrls: ['./mat-like-stepper.component.css']
})
export class MatLikeStepperComponent {

  @Input() steps: { label: string }[] = [];
  @Input() activeStep: number = 0;

}
